import { ReactQueryClientProvider } from './components/hoc';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { GoogleOAuthProvider } from '@react-oauth/google';
import fetcher from '@/components/api/fetcher.ts';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ENV } from './constants';
import { Toaster } from 'sonner';
import { SWRConfig } from 'swr';
import React from 'react';
import App from './app';
import '@/config';

import 'react-photo-view/dist/react-photo-view.css';
import './index.css';

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	enabled: ENV.name === 'production',
	environment: ENV.name,
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	// Performance Monitoring
	tracesSampleRate: 0.5, //  Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<SWRConfig value={{ fetcher }}>
			<Toaster richColors closeButton duration={2000} visibleToasts={1} position="top-right" />
			<GoogleOAuthProvider clientId={ENV.gcClientId}>
				<BrowserRouter>
					<NuqsAdapter>
						<ReactQueryClientProvider>
							<App />
						</ReactQueryClientProvider>
					</NuqsAdapter>
				</BrowserRouter>
			</GoogleOAuthProvider>
		</SWRConfig>
	</React.StrictMode>
);
